module.exports = __webpack_public_path__ + "6cc5345fd241e50bf24841452c2a2bb4.svg";